import { createFileRoute } from '@tanstack/react-router'
import { BasesOperacionaisPage } from '@/pages/bases-operacionais/BasesOperacionaisPage'

export const Route = createFileRoute('/_auth/bases-operacionais')({
  component: BasesOperacionaisPage,
})
